module.exports = __webpack_public_path__ + "img/aboutus-banner.d922c3a3.jpg";